<template>
  <div>
    <section class="hero-section" id="hero">
      <div class="container">
        <div class="row mt-5 pt-5">
          <div class="col-md-6 hero-text-image">
            <div class="row">
              <div class="col-lg-10 offset-sm-1 iphone-wrap">
                <img src="img/landing/main.png" alt="Image" class="img-fluid main" data-aos="fade-right">
                <img src="img/landing/key.svg" alt="" class="key" data-aos="fade-right">
                <div class="loading">
                  <img src="img/landing/loading.svg" alt="" data-aos="fade-right">
                  <p>Wait! <br> Hiding your api key</p>
                </div>
                <img src="img/landing/lock.svg" alt="" class="lock" data-aos="fade-right">
              </div>
              <div class="col-lg-12 text-center ">
                <h3 class="mb-3 text-center" data-aos="fade-right" data-aos-delay="100" style="color: white;">Use our
                  secure API relay server to hide your API key from the front end and inject it on the back end.</h3>
              </div>
              <div class="col-lg-12 text-center align-items-bottom">
                <div class="text-center text-md-left mt-5 mb-5 mb-md-0 " style="color: white;">
                  <h2 class="" style="color: white;">Latest updates</h2>
                    <ul>
                      <li><code>November 4, 2023:</code> Added HTTP method selection.</li>
                      <li><code>October 22, 2023:</code> Added <a href="https://openai.com">Open AI</a> APIs.</li>
                      <li><code>September 22, 2023:</code> Added <a href="https://play.ht">play.ht</a> sample API.</li>
                    <li><code>September 20, 2023:</code> Added support for <code>application/json content type</code> in POST requests.</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form contact-form shadow" id="tryitout">
              <h2 class="text-white mb-3 text-center">{{ title }}</h2>
              <hide-api-key-widget></hide-api-key-widget>
            </div>
          </div>
        </div>
      </div>

    </section>
    <center><a
        href="https://www.producthunt.com/posts/hideapikey?utm_source=badge-featured&utm_medium=badge&utm_souce=badge-hideapikey"
        target="_blank"><img
          src="https://api.producthunt.com/widgets/embed-image/v1/featured.svg?post_id=307053&theme=light"
          alt="hideAPIkey - Hide your API key from your front end | Product Hunt" style="width: 250px; height: 54px;"
          width="250" height="54" /></a></center>

    <main id="main">
      <section class="section" id="howitworks">
        <div class="container pt-3">
          <div class="row justify-content-center text-center mb-5">
            <div class="col-md-6" data-aos="fade-up">
              <h2 class="section-heading">How it Works</h2>
            </div>
          </div>
          <div class="row">
            <div class="col-md" data-aos="fade-up" data-aos-delay="">
              <div class="feature-1 text-center">
                <div class="wrap-icon icon-1">
                  <span class="icon la la-key"></span>
                </div>
                <h3 class="mb-3">Select from our API providers or use a custom URL</h3>
                <p>We store your credentials encrypted on our secure server and inject it into every API call.</p>
              </div>
            </div>


            <div class="col-md" data-aos="fade-up" data-aos-delay="100">
              <div class="feature-1 text-center">
                <div class="wrap-icon icon-1">
                  <span class="icon las la-redo-alt"></span>
                </div>
                <h3 class="mb-3">Replace your request URL</h3>
                <p>
                  You replace the URL of your API call with a call to our own API but without your API key. Your request headers and body are automatically forwarded. hideAPIkey.com always uses the secure HTTPS protocol even if
                  your API provider doesn't!
                </p>
              </div>
            </div>
            <div class="col-md" data-aos="fade-up" data-aos-delay="200">
              <div class="feature-1 text-center">
                <div class="wrap-icon icon-1">
                  <span class="icon las la-ban"></span>
                </div>
                <h3 class="mb-3">Don't expose your keys</h3>
                <p>
                  Your keys are hidden from the public and also from your team. Only communicate your relay URL.
                </p>
              </div>
            </div>
            <div class="col-md" data-aos="fade-up" data-aos-delay="200">
              <div class="feature-1 text-center">
                <div class="wrap-icon icon-1">
                  <span class="icon las la-server"></span>
                </div>
                <h3 class="mb-3">The relay server injects your key</h3>
                <p>
                  Your secret API key is injected as form parameter (if form data was received), header and query
                  parameter (for GET requests)
                </p>
              </div>
            </div>
            <div class="col-md" data-aos="fade-up" data-aos-delay="200">
              <div class="feature-1 text-center">
                <div class="wrap-icon icon-1">
                  <span class="icon las la-lock"></span>
                </div>
                <h3 class="mb-3">Secure your route</h3>
                <p>
                  Add a list of allowed hosts that can access your own route. All other hosts will not be able to call it.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="section cta-section">
        <div class="container">
          <div class="row align-items-center">
            <div class="col-md-6 mr-auto text-center text-md-left mb-5 mb-md-0">
              <h2 class="">Need to monitor the uptime of your API?</h2>
            </div>

            <div class="col-md-3 text-center text-md-left">
              <a href="https://monitorbuddy.com/" class="btn btn-primary" target="_blank">Try monitorbuddy.com</a>
            </div>
            <div class="col-md-3 text-center text-md-left">
              <img src="https://www.monitorbuddy.com/icon.svg" alt="MonitorBuddy" width="100" height="100">
            </div>

          </div>
          <div class="row align-items-center mt-5">
            <iframe src="https://www.monitorbuddy.com/status/69a3bf32-303a-4268-a4b5-71852f2adb4d"
              style="width: 100%; min-height: 450px;"></iframe>
          </div>
        </div>
      </section>

      <section class="section">
        <div class="container">
          <div class="row align-items-center">
            <div class="col-md-4 mr-auto">
              <h2 class="mb-4">Securing your credentials on the front end</h2>
              <p class="mb-4">
                There are numerous API providers that require you to use a personal API key on the front end. Examples of
                such providers are Google Maps, YouTube, MailChimp, Paddle or PayPal.
              </p>
              <p><a href="#howitworks" class="btn btn-primary">How it works</a></p>
              <p><a href="/getting-started" class="btn btn-primary">Getting started</a></p>
            </div>
            <div class="col-md-7" data-aos="fade-left">
              <img src="img/landing/custom-image.svg" alt="Image" class="img-fluid" />
            </div>
          </div>
        </div>
      </section>
      <a name="pricing" />
      <section class="section" id="pricing">
        <div class="container pt-3">
          <div class="row justify-content-center text-center">
            <div class="col-md-7 mb-5">
              <h2 class="section-heading">Pricing</h2>
              <p>
                There are numerous API providers that require you to use a
                personal API key on the front end. Examples of such providers
                are Google Maps etc.
              </p>
            </div>
          </div>
          <div class="row align-items-stretch">
            <div class="col-lg-4 mb-4 mb-lg-0">
              <div class="pricing h-100 text-center">
                <span>&nbsp;</span>
                <h3>Free Trial</h3>
                <ul class="list-unstyled">
                  <li>Free for 24 hours</li>
                  <li>Cancel anytime</li>
                </ul>
                <div class="price-cta">
                  <strong class="price"><a href="#tryitout" class="btn btn-primary">Start trial now</a></strong>
                </div>
              </div>
            </div>
            <div class="col-lg-4 mb-4 mb-lg-0">
              <div class="pricing h-100 text-center popular">
                <span class="popularity">Most Popular</span>
                <h3>Subscription</h3>
                <ul class="list-unstyled">
                  <li>Subscribe via link in e-mail</li>
                  <li>Cancel anytime</li>
                  <li>1 API key stored</li>
                  <li>Unlimited API calls</li>
                </ul>
                <div class="price-cta">
                  <strong class="price">$€£ 1/month</strong>
                </div>
              </div>
            </div>
            <div class="col-lg-4 mb-4 mb-lg-0">
              <div class="pricing h-100 text-center">
                <span class="popularity">Best Value</span>
                <h3>Enterprise</h3>
                <ul class="list-unstyled">
                  <li>Multiple API keys in one account</li>
                  <li>Custom integrations</li>
                  <li>Host on premise or in your cloud</li>
                  <li>Change your API keys automatically via our own API*</li>
                </ul>
                <small style="color: gray; padding-bottom: 20px;">*coming soon</small>
                <div class="price-cta">
                  <strong class="price"><a href="mailto:info@hideapikey.com">Contact us</a></strong>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="section cta-section">
        <div class="container">
          <div class="row align-items-center">
            <div class="col-md-6 mr-auto text-center text-md-left mb-5 mb-md-0">
              <h2 class="">Interested in API key security?</h2>

            </div>
            <div class="col-md-5 text-center text-md-left">


              <vue-mailchimp-email-signup-form title="Sign up now" :element-id="'first-email-signup-form'"
                :url="'https://hideapikey.us1.list-manage.com/subscribe/post?u=8930ce0e7015e3e7513f10640&amp;id=f910a41bae'" />

              <p class="text-white mb-0">
                Sign up for our hideAPIkey.com newsletter and security related
                information for your front-end.
              </p>


            </div>
          </div>
        </div>
      </section>
      <!--<section class="section">
        <div class="container">
          <div class="row">
            <div class="col-md-4">
              <div class="step">
                <span class="number">01</span>
                <h3>Secure</h3>
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipisicing elit. Rem,
                  optio.
                </p>
              </div>
            </div>
            <div class="col-md-4">
              <div class="step">
                <span class="number">02</span>
                <h3>Reliable</h3>
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipisicing elit. Rem,
                  optio.
                </p>
              </div>
            </div>
            <div class="col-md-4">
              <div class="step">
                <span class="number">03</span>
                <h3>Effective</h3>
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipisicing elit. Rem,
                  optio.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>-->

      <section class="section border-top border-bottom" id="contact">
        <div class="container">
          <div class="row">
            <div class="col-12 text-center">
              <h2 class="section-heading">Review From Our Users</h2>
              <div class="owl-carousel testimonial-carousel">
                <div class="review text-center">
                  <p class="stars">
                    <span class="icofont-star"></span>
                    <span class="icofont-star"></span>
                    <span class="icofont-star"></span>
                    <span class="icofont-star"></span>
                    <span class="icofont-star"></span>
                  </p>
                  <h3>No API keys in the wild!</h3>
                  <blockquote>
                    <p>
                      You can use hideAPIkey.com with our API to increase your security!
                    </p>
                  </blockquote>
                  <p class="review-user">
                    <img src="img/landing/resat.png" alt="Image" class="img-fluid rounded-circle mb-3" />
                    <span class="d-block">
                      <span class="text-black">Raetselinos</span> &mdash;
                      Hideapikey User
                    </span>
                  </p>
                </div>
                <!-- <div class="review text-center">
                  <p class="stars">
                    <span class="icofont-star"></span>
                    <span class="icofont-star"></span>
                    <span class="icofont-star"></span>
                    <span class="icofont-star"></span>
                    <span class="icofont-star"></span>
                  </p>
                  <h3>Awesome functionality!</h3>
                  <blockquote>
                    <p>
                      Lorem ipsum dolor sit amet, consectetur adipisicing elit.
                      Eius ea delectus pariatur, numquam aperiam dolore nam
                      optio dolorem facilis itaque voluptatum.
                    </p>
                  </blockquote>
                  <p class="review-user">
                    <img
                      src="img/landing/person_3.jpg"
                      alt="Image"
                      class="img-fluid rounded-circle mb-3"
                    />
                    <span class="d-block">
                      <span class="text-black">Jean Thunberg</span>, &mdash;
                      Hideapikey User
                    </span>
                  </p>
                </div> -->
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>

    <a href="#" class="back-to-top"><i class="icofont-simple-up"></i></a>
  </div>
</template>
<script>
import AOS from 'aos'
import HideApiKeyWidget from "../components/HideApiKeyWidget.vue";
import attachBanner from "../../node_modules/@beyonk/gdpr-cookie-consent-banner/dist/esm/bundle.js";
import axios from "axios";
import { VueMailchimpEmailSignupForm } from "vue-mailchimp-email-signup-form";


export default {
  name: "home",
  components: {
    HideApiKeyWidget,
    VueMailchimpEmailSignupForm
  },
  data: function () {
    return {
      newsletter_email: "",
      title: 'Get Started Now'
    };
  },
  mounted() {
    const options = {
      /**
       * You must set the cookie name.
       **/
      cookieName: "hideapikey_gdpr",

      /**
       * The cookie configuration, such as domain and path.
       **/
      cookieConfig: {
        domain: "hideapikey.com",
        path: "/",
      },

      /**
       * These are the top two lines of text on the banner
       * The 'description' field can include html such as links
       **/
      heading: "GDPR Notice",
      description:
        'We use cookies to offer a better browsing experience, analyze site traffic, personalize content, and serve targeted advertisements. Please review our <a href="/privacy-policy">privacy policy page</a>. By clicking accept, you consent to our privacy policy & use of cookies.',

      /**
       * All the button labels
       **/
      acceptLabel: "Accept",
      settingsLabel: "Preferences",
      closeLabel: "Close window",

      /**
       * These are the default opt-ins and their descriptions.
       * When value is set to true, the option will automatically be checked on load.
       *
       * If you don't want to show a category, simply remove the specified key from this object.
       **/
      choices: {
        necessary: {
          label: "Required cookies",
          description:
            "These can't be turned off as they are used to control all the other cookies",
          value: true,
        },
        analytics: false,
      },

      /**
       * Show an icon to edit cookies later, when banner is closed.
       **/
      showEditIcon: true,

      /**
       * These are the functions which are run if a user opts-in to that category.
       * You should drop your cookies here (or set a variable to control the later dropping of cookies.
       *
       * If you are using svelte, you can use events instead - see the Svelte section below.
       **/
      categories: {
        tracking: function () {
          let themejs = document.createElement("script");
          themejs.setAttribute(
            "src",
            "https://www.googletagmanager.com/gtag/js?id=G-Z1K6RVY03J"
          );
          document.head.appendChild(themejs);

          window.dataLayer = window.dataLayer || [];
          function gtag() {
            dataLayer.push(arguments);
          }
          gtag("js", new Date());

          gtag("config", "G-Z1K6RVY03J");
        },
        marketing: function () { },
        necessary: function () { },
      },
    };
    attachBanner(this.$refs.gdprBanner, options);
    const titleInfo = [
      {
        route: '/hide-google-maps-api-key',
        title: 'Hide your Google Maps API key'
      },
      {
        route: '/hide-pexels-api-key',
        title: 'Hide your Pexels API key'
      },
      {
        route: '/hide-pixabay-api-key',
        title: 'Hide your Pixabay API key'
      }
    ]
    const selecedtitle = titleInfo.find(obj => obj.route == this.$route.path)
    if (selecedtitle) {
      this.title = selecedtitle.title
    } else {
      this.title = 'Get Started Now'
    }
  },
  methods: {}
};
setTimeout(() => {
  AOS.init({
    easing: 'ease',
    duration: 1000,
    once: true
  });
}, 500)
</script>
<style scoped>
@import "../../node_modules/@beyonk/gdpr-cookie-consent-banner/dist/style.css";
@import "../plugins/icofont/icofont.min.css";
@import "../plugins/line-awesome/css/line-awesome.min.css";
@import "../plugins/owl.carousel/assets/owl.carousel.min.css";

@import "../../node_modules/vue-mailchimp-email-signup-form/dist/vue-mailchimp-email-signup-form.css";
</style>
